import { Link } from 'react-router-dom';

const footerLinks = [
  { href: '/kangaekata', label: '考え方' },
  { href: '/dekirukoto', label: 'できること' },
  { href: '/susumerkata', label: '進め方' },
  { href: '/faq', label: 'FAQ' },
  { href: '/cases', label: '事例一覧' },
  { href: '/company', label: '会社情報' },
  { href: '/message', label: 'メッセージ' },
  { href: '/contact', label: '相談する' },
];

export default function Footer() {
  return (
    <footer className="bg-warm-light border-t border-divider relative overflow-hidden">

      {/* 幾何学装飾 */}
      {/* 右上の同心円 */}
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full border border-accent-amber/12 pointer-events-none" />
      <div className="absolute -top-36 -right-36 w-96 h-96 rounded-full border border-accent-gold/8 pointer-events-none" />
      {/* 左下の同心円 */}
      <div className="absolute -bottom-20 -left-20 w-64 h-64 rounded-full border border-accent-teal/10 pointer-events-none" />
      {/* 菱形 */}
      <div className="absolute top-10 right-1/3 w-5 h-5 border border-accent-amber/25 rotate-45 pointer-events-none hidden lg:block" />
      <div className="absolute bottom-12 left-1/2 w-3 h-3 border border-accent-gold/30 rotate-45 pointer-events-none hidden lg:block" />
      {/* ドット群（左上） */}
      <div className="absolute top-8 left-8 pointer-events-none hidden lg:block">
        <div className="grid grid-cols-4 gap-3">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className="w-1 h-1 rounded-full bg-accent-amber/18" />
          ))}
        </div>
      </div>
      {/* ドット群（右下） */}
      <div className="absolute bottom-8 right-8 pointer-events-none hidden lg:block">
        <div className="grid grid-cols-3 gap-3">
          {Array.from({ length: 9 }).map((_, i) => (
            <div key={i} className="w-1 h-1 rounded-full bg-accent-gold/22" />
          ))}
        </div>
      </div>
      {/* 縦ライン */}
      <div className="absolute top-0 left-1/2 w-px h-12 bg-gradient-to-b from-accent-amber/20 to-transparent pointer-events-none hidden lg:block" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://static.readdy.ai/image/2971b814dc462dd4b8fae3beb50e2175/fe51ca6d464359b6727fc714a105c082.png"
                alt="mecena Intercom"
                className="h-8 w-auto object-contain"
              />
            </Link>
            <p className="text-sm font-sans-jp text-muted-brown leading-relaxed-jp mt-4 max-w-xs">
              意味を設計し、価値を創る。<br />
              地域と社会とともに。
            </p>
            <p className="text-xs font-garamond italic text-muted-light mt-2 max-w-xs leading-relaxed">
              Shaping meaning. Creating value.<br />
              With society.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-1">
            <p className="text-xs font-sans-jp text-muted-light tracking-widest-jp mb-6 uppercase">Navigation</p>
            <nav className="grid grid-cols-2 gap-x-8 gap-y-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm font-sans-jp text-muted-brown hover:text-accent-teal transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="md:col-span-1">
            <p className="text-xs font-sans-jp text-muted-light tracking-widest-jp mb-6 uppercase">Contact</p>
            <div className="space-y-4 mb-6">
              <div className="flex items-start gap-3">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-accent-teal text-xs" />
                </span>
                <p className="text-xs font-sans-jp text-muted-brown leading-relaxed-jp">
                  〒150-0036<br />
                  東京都渋谷区南平台町15-10<br />
                  南平台1510ビル 5階
                </p>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-accent-teal text-xs" />
                </span>
                <a
                  href="tel:0334059741"
                  className="text-xs font-sans-jp text-muted-brown hover:text-accent-teal transition-colors duration-200 whitespace-nowrap"
                >
                  03-3405-9741
                </a>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-accent-teal text-xs" />
                </span>
                <p className="text-xs font-sans-jp text-muted-brown whitespace-nowrap">
                  平日 10:00〜19:00 / 土日祝定休
                </p>
              </div>
            </div>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 border border-charcoal text-sm font-sans-jp text-charcoal hover:bg-charcoal hover:text-warm-white transition-all duration-300 whitespace-nowrap"
            >
              相談する →
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-divider flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs font-sans-jp text-muted-light tracking-wide-jp">
            © 2026 mecena Intercom. All rights reserved.
          </p>
          <p className="text-xs font-garamond italic text-muted-light">Designing meaning, creating value.</p>
        </div>
      </div>
    </footer>
  );
}

